import { commentsData } from '@/mocks/gossipData';

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            瓜友热议
          </h2>
          <p className="text-foreground-500 text-base">来看看大家都在讨论什么</p>
        </div>

        <div className="space-y-4">
          {commentsData.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-2xl p-5 md:p-6 border border-background-200/70 hover:border-primary-200 transition-all duration-200"
            >
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 md:w-12 md:h-12 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-3 mb-2 flex-wrap">
                    <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                      {item.name}
                    </span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-3">
                    {item.content}
                  </p>
                  <div className="flex items-center gap-4">
                    <span className="inline-flex items-center gap-1.5 text-xs text-foreground-400 cursor-default">
                      <i className="ri-thumb-up-line"></i>
                      {item.likes.toLocaleString()}
                    </span>
                    <span className="inline-flex items-center gap-1.5 text-xs text-foreground-400 cursor-default">
                      <i className="ri-chat-1-line"></i>
                      回复
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}